import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.less';

export const ListItem: FC<ListItemProps> = ({
  children,
  className,
  alignItems = 'center',
}) => {
  const classes = classNames(
    styles['list-item'],
    styles[`align-${alignItems}`],
    className,
  );

  return <li className={classes}>{children}</li>;
};

type ListItemProps = {
  children?: React.ReactNode;
  className?: string;
  alignItems?: 'center' | 'baseline';
};
